import PropTypes from 'prop-types';
import styled from 'styled-components';
import Link from '../Link';

import { ReactComponent as Edit } from '../../assets/images/svg/edit.svg';
import themeColors from '../../assets/styles/themeColors';

const EditWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const EditStyled = styled(Edit)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextGrey};
  ${({ mr }) =>
    mr && `margin-right: ${mr}px;`}/* position: absolute;
  bottom: 0; */
`;

const EditIcon = ({ dataCy, ...props }) => (
  <EditWrapper data-cy={dataCy} {...props}>
    <EditStyled mr={5} {...props} />
    <Link editStyle title="Edit" />
  </EditWrapper>
);

EditIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
  dataCy: PropTypes.string,
  props: PropTypes.shape({}),
};

EditIcon.defaultProps = {
  w: '12px',
  h: '12px',
};

export default EditIcon;
